import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import ApiService from "services/ApiService";
import AuthService from "services/AuthService";
import { ContextOne } from "contexts/ContextOne";
import { dateLocalDisplay } from "lib/Utils";
import Spinner from "components/UI/Spinner";
import { ToasterContext } from "contexts/ToasterContext";
import AiModelFullForm from "components/AiModels/AiModelFullForm"

import withAuth from "withAuth";

import "./AiModel.scss";


const AiModel = () => {
  const { uuid } = useParams();

  const { state: { loading }, dispatch } = useContext(ContextOne);
  const { AddToast } = useContext(ToasterContext);

  const [aiModel, setAiModel] = useState(null);

  // Data Fetching

  const fetchData = async () => {
    dispatch({ type: "loading", val: true });

    const data = await ApiService.getAiModel(uuid);
    setAiModel(data);

    dispatch({ type: "loading", val: false });
  };

  const handleAiModelSubmit = async (aiModel) => {

    var data = {
      artist: aiModel.artist,
      description: aiModel.description,
      pth_file: aiModel.pthFile,
      model_index_file_location: aiModel.indexFile,
      model_name: aiModel.modelName,
      epochs: aiModel.epochs,
      technology: aiModel.technology,
      f0: aiModel.f0,
      visibility_status: aiModel.visibilityStatus,
      pitch_guidance: aiModel.pitchGuidance,
      sample_rate_k: aiModel.sampleRateK,
      use_noise_filter: aiModel.useNoiseFilter,
      crepe_hop_length: aiModel.crepeHopLength
    };

    dispatch({ type: "loading", val: true });

    AuthService.fetch(`${process.env.REACT_APP_API_ENDPOINT}/ai_models/${uuid}/update`, {
      method: "PATCH",
      body: JSON.stringify(data)
    })
    .then(
      async (result) => {
        await fetchData();
        AddToast("success", "AI Model Updated", null);
        return;
      },
      (error) => {
        AddToast("danger", null, error);
        return;
      }
    )
    .then(() => {
      dispatch({ type: "loading", val: false });
    });
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="ai-model-component">
      <Spinner show={loading} />

      <div className="text-center">
        {aiModel && (
          <>
            <div className="ai-model-header">
              <div className="ai-model-name">
                Model: {aiModel.model_name}
              </div>
              <div className="ai-model-description">
                Description: {aiModel.description}
              </div>
              <div className="ai-model-processing-status">
                Processing Status: {aiModel.processing_status}
              </div>
              <div className="ai-model-created">
                created by: {aiModel.created_by}, {dateLocalDisplay(aiModel.created_at)}
              </div>
            </div>

            <AiModelFullForm
              handleSubmit={handleAiModelSubmit}
              aiModel={aiModel}
            />
          </>
      )}
      </div>
    </div>
  );
};

export default withAuth(AiModel);
